import { TextField, Button, Alert } from "@mui/material";
import "../styles/evergreenForm.scss";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

export default function EvergreenForm() {
  const [personalDetails, setPersonalDetails] = useState(true);
  const url = "https://dev.pmwwebdesign.com";
  const navigate = useNavigate();

  // Form field input states
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [revenue, setRevenue] = useState("");
  // const [eliteRetreat, setEliteRetreat] = useState("");
  const [question1, setQuestion1] = useState("");
  const [question2, setQuestion2] = useState("");
  const [question3, setQuestion3] = useState("");
  const [question4, setQuestion4] = useState("");
  const [question5, setQuestion5] = useState("");
  const [question6, setQuestion6] = useState("");

  // !ALERTS
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("");

  const handleAlert = (message, severity, duration = 3000) => {
    setMessage(message);
    setSeverity(severity);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
      setMessage("");
      setSeverity("");
    }, duration);
  };

  const handleNext = () => {
    //Checking fields have input
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^[0-9]*$/;

    if (email === "" || phone === "") {
      handleAlert("Please fill in email and phone", "warning");
    } else if (first === "" || last === "") {
      handleAlert("Please fill in first and last name", "warning");
    } else if (!email.match(regex)) {
      handleAlert("Please insert an email address", "warning");
    } else if (!phone.match(phoneRegex)) {
      handleAlert("Please insert a phone number", "warning");
    } else if (regex === "") {
      handleAlert("Please select your business revenue", "warning");
    } 
    // else if (eliteRetreat === "") {
    //   handleAlert("Please select an Elite Retreat option", "warning");
    // } 
    else {
      let cartData = {
        email: email,
        phone: phone,
      };

      axios
        .post(`${url}/mastermind/abandon-cart`, cartData)
        .then((res) => {
          console.log(res.data);
          setPersonalDetails(false);
        })
        .catch((err) => {
          console.log(err);
          setPersonalDetails(false);
        })
        .catch((err) => {
          console.log(err);
          handleAlert("Something went wrong, please try again", "error");
        });
    }
  };

  const handleSubmit = () => {
    //Checking fields have input

    if (
      question1 === "" ||
      question2 === "" ||
      question3 === "" ||
      question4 === "" ||
      question5 === "" ||
      question6 === ""
    ) {
      handleAlert("Please answer all questions", "warning");
    } else {
      let data = {
        first: first,
        last: last,
        email: email,
        phone: phone,
        revenue: revenue,
        // eliteRetreat: eliteRetreat,
        question1: question1,
        question2: question2,
        question3: question3,
        question4: question4,
        question5: question5,
        question6: question6,
      };
      localStorage.setItem("masterClient", JSON.stringify(data))
        axios
          .post(`${url}/mastermind/call`, data)
          .then((res) => {
            console.log(res.data);
            navigate("/thank-you?form=true");
          })
          .catch((err) => {
            console.log(err);
            handleAlert("Something went wrong, please try again", "error");
          });
    }
  };

  return (
    <>
      {personalDetails ? (
        <section>
          <h2>Please fill in your details:</h2>
          <section className="form">
            <TextField
              required
              className="text--field"
              value={first}
              onChange={(e) => setFirst(e.target.value)}
              placeholder="First Name"
            />

            <TextField
              required
              className="text--field"
              value={last}
              onChange={(e) => setLast(e.target.value)}
              placeholder="Last Name"
            />

            <TextField
              required
              className="text--field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
            />

            <TextField
              required
              className="text--field"
              pattern="[0-9]*"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone"
            />

            <div className="form-single small-text">
              <label>What is your current business annual revenue</label>
              <Select
                value={revenue}
                onChange={(e) => setRevenue(e.target.value)}
              >
                <MenuItem value="0-50K">0-50K</MenuItem>
                <MenuItem value="50-150K">50-150K</MenuItem>
                <MenuItem value="150K-500K">150K-500K</MenuItem>
                <MenuItem value="500K-1M">500K-1M</MenuItem>
                <MenuItem value="1M+">1M+</MenuItem>
              </Select>
            </div>
            {/* <div className="form-single small-text">
              <label>
                {" "}
                Would you like to add the no-cost Elite Retreat to your
                application? (SBC ONLY)
              </label>
              <Select
                value={eliteRetreat}
                onChange={(e) => setEliteRetreat(e.target.value)}
              >
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </div> */}
          </section>
          <div className="alert-section">
            {showAlert ? <Alert severity={severity}>{message}</Alert> : null}{" "}
          </div>
          <Button
            className="evergreen--btn"
            variant="outlined"
            onClick={handleNext}
          >
            Next
          </Button>
        </section>
      ) : (
        <>
          {/* Extra Questions */}
          <section className="form">
            <div className="form-single large-text">
              <label>1. How did you hear about the Elite Mastermind?</label>
              <textarea
                required
                className="text--field--area"
                value={question1}
                onChange={(e) => setQuestion1(e.target.value)}
                rows={6}
              />
            </div>
            <div className="form-single large-text">
              <label>
                2. What is your current occupation or business? Please briefly
                describe what you do.
              </label>
              <textarea
                required
                className="text--field--area"
                value={question2}
                onChange={(e) => setQuestion2(e.target.value)}
                rows={6}
              />
            </div>
            <div className="form-single">
              <label>
                3. How long have you been in business, and what stage is your
                business at? (e.g., startup, scaling, established)?
              </label>
              <textarea
                required
                className="text--field--area"
                value={question3}
                onChange={(e) => setQuestion3(e.target.value)}
                rows={6}
              />
            </div>
            <div className="form-single">
              <label>
                4. What motivated you to start/build your business, and what is
                your ultimate goal?
              </label>
              <textarea
                required
                className="text--field--area"
                value={question4}
                onChange={(e) => setQuestion4(e.target.value)}
                rows={6}
              />
            </div>
            <div className="form-single">
              <label>
                {" "}
                5. What’s your current big business challenge and how have you
                approached solving it?
              </label>
              <textarea
                required
                className="text--field--area"
                value={question5}
                onChange={(e) => setQuestion5(e.target.value)}
                rows={6}
              />
            </div>
            <div className="form-single">
              <label>
                6. What specific goals or milestones do you want to achieve in
                the next 12 months?
              </label>
              <textarea
                required
                className="text--field--area"
                value={question6}
                onChange={(e) => setQuestion6(e.target.value)}
                rows={6}
              />
            </div>

            <Button
              className="evergreen--btn"
              variant="outlined"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </section>
        </>
      )}
    </>
  );
}
